export const wordToBoolean = (word) => {
    if (typeof word === 'boolean') return word
    let x = word.toLowerCase().trim()
    if (x === 'true') return true
    else if (x === 'false') return false
    else return undefined
}

// add or remove from requiredAtLockLevel
export const modifyMissingRequiredLockLevelFields = (
    newMissingRequiredLockLevelFields,
    fieldId,
    lockLevel,
    action
) => {
    // const modifyRequiredAtLockLevels = (fieldId, lockLevel, action) => {
    let bChange = false
    // let newMissingRequiredLockLevelFields = missingRequiredLockLevelFields;
    let newMissingReqLLSingle = newMissingRequiredLockLevelFields[lockLevel]
    if (newMissingReqLLSingle) {
        let fieldIdx = newMissingReqLLSingle.indexOf(fieldId)
        if (fieldIdx === -1 && action.toUpperCase() === 'ADD') {
            bChange = true
            newMissingReqLLSingle.push(fieldId)
        } else if (fieldIdx > -1 && action.toUpperCase() === 'REMOVE') {
            bChange = true
            newMissingReqLLSingle.splice(fieldIdx, 1)
        }

        newMissingRequiredLockLevelFields[lockLevel] = newMissingReqLLSingle
    }
    // setMissingRequiredLockLevelFields(newMissingRequiredLockLevelFields);
    //return newMissingRequiredLockLevelFields;
    return bChange
}

export const numericStepToFixed = (rawNumber, step) => {
    if (step === 0) return rawNumber
    let numPlaces = -1
    let max = 10
    let curr = 0
    let currStep = step
    while (curr < max && numPlaces === -1) {
        if (currStep < 1) {
            currStep *= 10
        } else {
            numPlaces = curr
        }
        curr += 1
    }

    return rawNumber.toFixed(numPlaces === -1 ? 0 : numPlaces)
}

export const updateLockedLevels = (num, numberString) => {
    console.log('numberString:', numberString)

    if(numberString===''){
        numberString='0'
    }
    // Handle cases where numberString is a direct number (e.g., 0)
    let numbersArray =
        typeof numberString === 'number'
            ? [numberString]
            : numberString
            ? numberString.split('|').map(Number)
            : []

    // Check if the number is already in the array
    if (numbersArray.includes(num)) {
        // If it is, remove it
        numbersArray = numbersArray.filter((number) => number !== num)
    } else {
        // If it's not, add it
        numbersArray.push(num)
    }

    // Sort the array in ascending order
    numbersArray.sort((a, b) => a - b)

    // Join the array back into a string
    const newNumberString = numbersArray.join('|')
    console.log('updateLockedLevels:', newNumberString)

    // Return the new string
    return newNumberString
}

export const checkIfIsLocking = (num, numberString) => {
    console.log('numberString:', numberString)

    // Handle case where numberString is a direct number and equals num
    if (typeof numberString === 'number' && numberString === num) {
        return false
    }

    // Handle case where numberString is a valid string like "0|1|2"
    if (typeof numberString === 'string') {
        const numbersArray = numberString.split('|').map(Number)
        return !numbersArray.includes(num)
    }

    // Default to false if neither condition matches
    return false
}

export const checkIfMoreThanOneLockIsUnlock = (numberString, maxNum) => {
    let numbersArray = numberString
        .split('|')
        .map(Number)
        .sort((a, b) => a - b)
    let missingCount = 0
console.log(numbersArray)
    for (let i = 0; i < numbersArray.length - 1; i++) {
        let diff = numbersArray[i + 1] - numbersArray[i]
        if (diff > 1) {
            missingCount += diff - 1
        }
    }
    // Check for missing numbers between the last number in the array and the maxNum
    if (numbersArray.length > 0 && numbersArray[numbersArray.length - 1] < maxNum) {
        missingCount += maxNum - numbersArray[numbersArray.length - 1]
    }

    // Check for missing numbers between 0 and the first number in the array
    if (numbersArray.length > 0 && numbersArray[0] > 0) {
        missingCount += numbersArray[0]
    }
    console.log('checkIfMoreThanOneLockIsUnlock')
    console.log(missingCount)
    return missingCount < 1
}

export const findCurrentLockLevel = (lockedLevels) => {
    if (lockedLevels.trim() === '') {
        return 0
    }

    const numbers = lockedLevels.split('|').map((num) => parseInt(num, 10))
    return Math.max(...numbers)
}

export const isValidDate = (dateString) => {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false

    // Parse the date parts to integers
    const parts = dateString.split('/')
    const day = parseInt(parts[1], 10)
    const month = parseInt(parts[0], 10)
    const year = parseInt(parts[2], 10)

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) return false

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1]
}

export function GetUniqueMultiValues(multiValueArray) {
    const idSet = new Set()
    let newFormSectionFieldMultiValue = []
    function addUniqueItem(array, newItem) {
        if (!idSet.has(newItem.StringFieldValue)) {
            array.push(newItem)
            idSet.add(newItem.StringFieldValue)
        }
    }

    for (let i = 0; i < multiValueArray.length; i++) {
        addUniqueItem(
            newFormSectionFieldMultiValue,
            multiValueArray[i]
        )
    }
    return newFormSectionFieldMultiValue
}
